import{NgModule}from '@angular/core';
import{IconComponent} from './svg-icons.component';

@NgModule({
  providers:[],
  declarations:[IconComponent],
  exports:[IconComponent]
})
export class IconModule{}
